module.exports = __webpack_public_path__ + "img/logo-light.1530b00b.png";